import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { JobPositionService } from '../../../services/JobPosition/JobPositionService'
import { JobPosition } from '../../../services/JobPosition/types'

export interface IDeleteJobPositionDialogProps {
  isOpen: boolean
  onClose: () => void
  jobPosition: JobPosition
  leastDestructiveRef: any
}

export function JobPositionDeleteDialog({
  isOpen,
  onClose,
  jobPosition,
  leastDestructiveRef
}: IDeleteJobPositionDialogProps) {
  const service = new JobPositionService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await service.delete(jobPosition.id)

      toast({
        title: 'Vaga excluída com sucesso',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao excluir vaga',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Remover vaga &quot;{jobPosition.name}&quot;
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja fazer isso?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
